<template>
  <div class="space-y-8">
    <!-- Project Clients Card -->
    <div class="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
      <div class="px-6 py-4 border-b border-gray-200 bg-gradient-to-r from-gray-50 to-gray-100">
        <div class="flex items-center justify-between">
          <div class="flex items-center space-x-3">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" class="w-5 h-5 text-gray-600">
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"></path>
</svg>

            <div>
              <h3 class="text-lg font-semibold text-gray-900">
                Project Clients
              </h3>

              <p class="text-sm text-gray-600">
                Manage clients with access to this project
              </p>
            </div>
          </div>

          <button
            type="button"
            class="btn btn--primary-blue flex items-center space-x-2"
            @click="showInviteModal = true"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-4 h-4">
  <path fill-rule="evenodd" d="M12 3.75a.75.75 0 01.75.75v6.75h6.75a.75.75 0 010 1.5h-6.75v6.75a.75.75 0 01-1.5 0v-6.75H4.5a.75.75 0 010-1.5h6.75V4.5a.75.75 0 01.75-.75z" clip-rule="evenodd" />
</svg>

            <span>{{ $t('ProjectSettings.ClientsTab.button.inviteClient') }}</span>
          </button>
        </div>
      </div>

      <div class="p-6">
        <!-- Loading State -->
        <div
          v-if="indexClientsAction.is(States.LOADING)"
          class="text-center py-12"
        >
          <AppSpinner class="h-8 w-8 mx-auto mb-4" />

          <p class="text-gray-600">
            Loading clients...
          </p>
        </div>

        <!-- Clients Table -->
        <div
          v-else-if="indexClientsAction.is(States.COMPLETE) && users.length > 0"
          class="overflow-hidden border border-gray-200 rounded-lg"
        >
          <table class="min-w-full divide-y divide-gray-200">
            <thead class="bg-gray-50">
              <tr>
                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  {{ $t('ProjectSettings.ClientsTab.table.email') }}
                </th>

                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  {{ $t('ProjectSettings.ClientsTab.table.name') }}
                </th>

                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  {{ $t('ProjectSettings.ClientsTab.table.lastLogin') }}
                </th>

                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Actions
                </th>
              </tr>
            </thead>

            <tbody class="bg-white divide-y divide-gray-200">
              <tr
                v-for="permission in users"
                :key="permission.user_id"
                class="hover:bg-gray-50 transition-colors"
              >
                <td class="px-6 py-4 whitespace-nowrap">
                  <div class="flex items-center">
                    <div class="flex-shrink-0 h-8 w-8">
                      <div class="h-8 w-8 rounded-full bg-gray-200 flex items-center justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-4 w-4 text-gray-500">
  <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z" />
</svg>
                      </div>
                    </div>

                    <div class="ml-3">
                      <div class="text-sm font-medium text-gray-900">
                        {{ permission.user.email }}
                      </div>
                    </div>
                  </div>
                </td>

                <td class="px-6 py-4 whitespace-nowrap">
                  <div class="text-sm text-gray-900">
                    {{ permission.user.name }}
                  </div>
                </td>

                <td class="px-6 py-4 whitespace-nowrap">
                  <div class="text-sm text-gray-900">
                    {{ permission.user.last_login_at ? DateTime.fromISO(permission.user.last_login_at).toLocaleString(DateTime.DATETIME_SHORT) : t('ProjectSettings.ClientsTab.table.never') }}
                  </div>
                </td>

                <td class="px-6 py-4 whitespace-nowrap text-sm font-medium">
                  <button
                    type="button"
                    class="text-red-600 hover:text-red-900 transition-colors"
                    data-test="trash"
                    @click="deleteClient(permission.user)"
                  >
                    <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
    />
</svg>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Empty State -->
        <div
          v-else-if="indexClientsAction.is(States.COMPLETE) && users.length === 0"
          class="text-center py-12"
        >
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" class="mx-auto h-12 w-12 text-gray-400 mb-4">
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"></path>
</svg>

          <h3 class="text-sm font-medium text-gray-900 mb-1">
            {{ $t('ProjectSettings.ClientsTab.empty.noClients') }}
          </h3>

          <p class="text-sm text-gray-500 mb-6">
            Get started by inviting your first client to the project.
          </p>

          <button
            type="button"
            class="btn btn--primary-blue flex items-center space-x-2 mx-auto"
            @click="showInviteModal = true"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-4 h-4">
  <path fill-rule="evenodd" d="M12 3.75a.75.75 0 01.75.75v6.75h6.75a.75.75 0 010 1.5h-6.75v6.75a.75.75 0 01-1.5 0v-6.75H4.5a.75.75 0 010-1.5h6.75V4.5a.75.75 0 01.75-.75z" clip-rule="evenodd" />
</svg>

            <span>{{ $t('ProjectSettings.ClientsTab.button.inviteClient') }}</span>
          </button>
        </div>
      </div>
    </div>

    <Modal
      v-if="showInviteModal"
      @close="showInviteModal = false"
    >
      <template #header>
        <div class="w-full text-center">
          <h1 class="text-2xl">
            {{ $t('ProjectSettings.ClientsTab.modal.inviteClient.title') }}
          </h1>
        </div>
      </template>

      <template #body>
        <div class="h-full w-full">
          <form @submit.prevent="inviteUser">
            <label>
              {{ $t('ProjectSettings.ClientsTab.modal.inviteClient.form.email') }}

              <div class="relative">
                <AppSpinner
                  v-if="searchClientsAction.is(States.LOADING)"
                  class="absolute my-3 right-2"
                  spinner-class="h-4 w-4"
                />

                <AppInput
                  v-model="clientForm.form.email"
                  type="text"
                  name="email"
                  class="form-input pr-8"
                  :error="clientForm.getErrors('email')"
                />
              </div>

              <p
                v-if="userFound"
                class="text-xs text-ccm-blue-500 font-semibold"
              >
                {{ $t('ProjectSettings.ClientsTab.modal.inviteClient.form.userFound') }}
              </p>
            </label>

            <label>
              {{ $t('ProjectSettings.ClientsTab.modal.inviteClient.form.name') }}
              <AppInput
                v-model="clientForm.form.name"
                type="text"
                name="name"
                class="form-input"
                :error="clientForm.getErrors('name')"
                :disabled="userFound"
              />
            </label>
          </form>
        </div>
      </template>

      <template #footer>
        <div class="w-full flex justify-end space-x-4">
          <button
            type="button"
            class="btn btn--secondary-blue"
            @click="showInviteModal = false"
          >
            {{ $t('ProjectSettings.ClientsTab.modal.inviteClient.buttons.cancel') }}
          </button>

          <button
            type="button"
            class="btn btn--primary-blue"
            @click="inviteUser"
          >
            {{ $t('ProjectSettings.ClientsTab.modal.inviteClient.buttons.invite') }}
          </button>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script setup lang="ts">
import Modal from '@/components/Modal.vue';
import { useFormData } from '@/composables/useFormData';
import { States, useStoreApiAction } from '@/composables/useStoreApiAction';
import { t } from '@/i18n';
import Permissions from '@/models/Permissions';
import User from '@/models/User';
import { useProjectsStore } from '@/store/projects';
import { useRolesStore } from '@/store/roles';
import { useUserStore } from '@/store/user';
import { useDebounceFn } from '@vueuse/core';
import { DateTime } from 'luxon';
import { useRepo } from 'pinia-orm';
import Swal from 'sweetalert2';
import { computed, ref, watch } from 'vue';

const emits = defineEmits<{
  (e: 'dirty');
  (e: 'saved');
}>();

const userStore = useUserStore();
const projectsStore = useProjectsStore();
const rolesStore = useRolesStore();

const users = computed(() => {
  const roles = rolesStore.models.where('name', (name: RoleTypes) => {
    return name === 'client_manager';
  }).get().map((role) => role.id)[0];

  return useRepo(Permissions)
    .with('user')
    .where('role_id', roles)
    .where('project_id', projectsStore.project.id)
    .whereNotIn('id', [userStore.user.id])
    .get();
});

const indexClientsAction = useStoreApiAction(userStore.indexClient);
const searchClientsAction = useStoreApiAction(userStore.searchClient);
const createClientAction = useStoreApiAction(userStore.createClient);
const deleteClientAction = useStoreApiAction(userStore.deleteClient);

indexClientsAction.request(projectsStore.project.id);

const clientForm = useFormData({
  name: '',
  email: '',
});

const userFound = ref(false);

const searchClient = useDebounceFn(async () => {
  searchClientsAction.request(projectsStore.project.id, {
    email: clientForm.form.email,
  }).then((userToInvite) => {
    if(userToInvite?.id) {
      userFound.value = true;
      clientForm.setData(userToInvite, ['email']);
    } else {
      userFound.value = false;
      clientForm.resetData(['name']);
    }
  });
}, 500);

watch(() => clientForm.form.email, (newValue) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if(newValue && emailRegex.test(newValue)) {
    searchClient();
  }
});

const showInviteModal = ref(false);

const inviteUser = () => {
  createClientAction.request(projectsStore.project.id, clientForm.form).then(() => {
    Swal.fire({
      icon: 'success',
      title: t('ProjectSettings.ClientsTab.modal.removeClient.inviteSuccess'),
    });

    clientForm.resetData();
    userFound.value = false;
  }).catch((error) => {
    if(error?.status === 422) {
      clientForm.setErrors(error.data);
    } else if(error?.status === 403) {
      Swal.fire({
        icon: 'error',
        text: error.data.message,
      });
    }
  });
};

const deleteClient = (user: User) => {
  Swal.fire({
    icon: 'warning',
    title: t('ProjectSettings.ClientsTab.modal.removeClient.title'),
    text: t('ProjectSettings.ClientsTab.modal.removeClient.confirmText', { name: user.name }),
    showConfirmButton: true,
    showCancelButton: true,
  }).then((result) => {
    if(result.isConfirmed) {
      deleteClientAction.request(projectsStore.project.id, user.id).then(() => {
        Swal.fire({
          icon: 'success',
          title: t('ProjectSettings.ClientsTab.modal.removeClient.success'),
        });
      });
    }
  });
};
</script>

<style scoped></style>
